import { RootState } from 'store';

export const selectLoading = (state: RootState) => state.request.loading;
export const selectRequest = (state: RootState) => state.request.request;
export const selectResponses = (state: RootState) => state.request.responses;
export const selectRequests = (state: RootState) => state.request.requests;
export const selectProcessing = (state: RootState) => state.request.processing;
export const selectServiceAction = (state: RootState) => state.request.serviceAction;
